var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1LeftRightArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 36V26l12 12-12 12V40H26v10L14 38l12-12v10h24z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Left-right_arrow_B.7cbd3cea.svg";
export { SvgJ1LeftRightArrowB as ReactComponent };